(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bouquet-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (builder) => {
      if (builder.dataset.initialized === 'true') return;
      builder.dataset.initialized = 'true';

      const rows = [...builder.querySelectorAll('[data-bouquet-row]')];
      const summary = builder.querySelector('[data-bouquet-summary]');
      const empty = builder.querySelector('[data-empty-summary]');
      const total = builder.querySelector('[data-bouquet-total]');
      const addButton = builder.querySelector('[data-add-bouquet]');
      const error = builder.querySelector('[data-bouquet-error]');

      const selectedItems = () => rows.map((row) => {
        const quantity = Math.max(0, Number.parseInt(row.querySelector('[data-quantity-input]').value, 10) || 0);
        return { id: Number(row.dataset.variantId), quantity, title: row.dataset.title };
      }).filter((item) => item.quantity > 0);

      const renderSummary = () => {
        const items = selectedItems();
        const count = items.reduce((sum, item) => sum + item.quantity, 0);
        summary.replaceChildren(...items.map((item) => {
          const entry = document.createElement('li');
          entry.textContent = `${item.title} × ${item.quantity}`;
          return entry;
        }));
        summary.hidden = items.length === 0;
        empty.hidden = items.length > 0;
        total.textContent = `${builder.dataset.totalLabel}: ${count}`;
        addButton.disabled = items.length === 0;
        error.hidden = true;
      };

      builder.addEventListener('click', (event) => {
        const row = event.target.closest('[data-bouquet-row]');
        if (row && (event.target.matches('[data-quantity-minus]') || event.target.matches('[data-quantity-plus]'))) {
          const input = row.querySelector('[data-quantity-input]');
          const current = Number.parseInt(input.value, 10) || 0;
          input.value = event.target.matches('[data-quantity-plus]') ? current + 1 : Math.max(0, current - 1);
          renderSummary();
        }
      });

      builder.addEventListener('input', (event) => {
        if (!event.target.matches('[data-quantity-input]')) return;
        event.target.value = Math.max(0, Number.parseInt(event.target.value, 10) || 0);
        renderSummary();
      });

      addButton.addEventListener('click', async () => {
        const items = selectedItems().map(({ id, quantity }) => ({ id, quantity }));
        if (!items.length) return;
        addButton.disabled = true;
        addButton.textContent = builder.dataset.addingText;
        error.hidden = true;
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.href = window.Shopify.routes.root + 'cart';
        } catch (_error) {
          error.textContent = builder.dataset.errorText;
          error.hidden = false;
          addButton.disabled = false;
          addButton.textContent = builder.dataset.addText;
        }
      });

      renderSummary();
    };

    document.querySelectorAll('.bouquet-builder').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.bouquet-builder').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
